/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = None
 *
 * 1 = WebClient
 *
 * 2 = AdminPanel
 *
 * 3 = Deal
 *
 * 4 = BookingLog
 */
export enum ServicePlanQuotaSoruce {
  None = 0,
  WebClient = 1,
  AdminPanel = 2,
  Deal = 3,
  BookingLog = 4,
}
